module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/success-icon.06bbb25f.svg";